// src/config/activeDaysConfig.js

export const activeDaysConfig = {
  sunday: false,
  monday: true,
  tuesday: true,
  wednesday: true,
  thursday: true,
  friday: true,
  saturday: false,
};
